module.exports = __webpack_public_path__ + "img/train-10.f367a735.jpg";